import React from 'react'

import { string, bool, func } from 'prop-types'

import CheckoutShareModal from 'Pods/CheckoutShare/CheckoutShareModal'
import LibTabs from 'Pods/Shared/Tabs/LibTabs'
import Login from 'Pods/Shared/User/Login'
import Register from 'Pods/Shared/User/Register'

import GuestCheckoutWithRegistration from './GuestCheckoutWithRegistration'

function UserModalWithTabs({
  source = null,
  fromCheckout = false,
  shouldOpen = false,
  onClose,
  afterOpenModal = null,
  showVerificationNotice = false,
  useVerificationFlow = false,
}) {
  return (
    <CheckoutShareModal
      isOpen={shouldOpen}
      onClose={onClose}
      afterOpenModal={afterOpenModal}
    >
      <LibTabs
        tabs={[
          {
            title: 'Guest checkout',
            id: 'guest',
            contents: (
              <GuestCheckoutWithRegistration
                showVerificationNotice={showVerificationNotice}
                useVerificationFlow={useVerificationFlow}
              />
            ),
          },
          {
            title: 'Register',
            id: 'register',
            contents: (
              <Register
                source={source}
                fromCheckout={fromCheckout}
                captchaId="registration-captcha"
                showEmailAvailability
              />
            ),
          },
          { title: 'Log in', id: 'login', contents: <Login captchaId="main-captcha" /> },
        ]}
        activeTabId="guest"
        containerClass="checkout-tabs"
      />
    </CheckoutShareModal>
  )
}

UserModalWithTabs.propTypes = {
  source: string,
  fromCheckout: bool,
  shouldOpen: bool,
  onClose: func.isRequired,
  afterOpenModal: func,
  showVerificationNotice: bool,
  useVerificationFlow: bool,
}

export default UserModalWithTabs
